require('./style.scss');
var tmpl = require('./main.ejs');
var Events = require('f.core.event');
var util = require('f.core.mobile.util');

var Title = function (title, channelName, channelIcon) {
  this.title = title;
  this.channelName = channelName;
  this.channelIcon = channelIcon;
  this.init();
};

Title.prototype.init = function () {
  this.initDom();
  this.initEvent();
};

Title.prototype.initDom = function () {
  var div = document.createElement('div');
  div.innerHTML = tmpl({title: this.title, channelName: this.channelName, channelIcon: this.channelIcon});
  this.el = div.children[0];
  this.elExitBtn = this.el.querySelector('.c-video__exit');
};

Title.prototype.initEvent = function () {
  util.tap(this.elExitBtn, function () {
    this.trigger('exit');
    return false;
  }, {
    scope: this
  });
};

Title.prototype.hide = function () {
  $(this.el).stop().animate({
    top: '-300px'
  });
  // this.el.style.display = 'none';
};


Title.prototype.show = function () {
  $(this.el).stop().animate({
    top: '0'
  });
  // this.el.style.display = 'block';
};

Title.prototype.renderTo = function (parentNode) {
  parentNode.appendChild(this.el);
};

Title.prototype.destory = function () {
  this.el.parentNode.removeChild(this.el);
};

Events.mixTo(Title);

module.exports = Title;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/title/index.js